var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoProduct(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 124,
    height: 124,
    rx: 62,
    fill: "#E5E5E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.375 40.4386H59.1875C59.7053 40.4386 60.125 40.8583 60.125 41.3761V59.1886C60.125 59.7064 59.7053 60.1261 59.1875 60.1261H41.375C40.8572 60.1261 40.4375 59.7064 40.4375 59.1886V41.3761C40.4375 40.8583 40.8572 40.4386 41.375 40.4386ZM74.4403 38.9543L85.0469 49.5609C85.413 49.927 85.413 50.5205 85.0469 50.8867L74.4402 61.4933C74.0741 61.8594 73.4806 61.8594 73.1144 61.4933L62.5078 50.8866C62.1417 50.5205 62.1417 49.927 62.5078 49.5608L73.1145 38.9543C73.4806 38.5882 74.0741 38.5882 74.4403 38.9543ZM41.375 63.8761H59.1875C59.7053 63.8761 60.125 64.2958 60.125 64.8136V82.6261C60.125 83.1439 59.7053 83.5636 59.1875 83.5636H41.375C40.8572 83.5636 40.4375 83.1439 40.4375 82.6261V64.8136C40.4375 64.2958 40.8572 63.8761 41.375 63.8761ZM64.8125 63.8761H82.625C83.1428 63.8761 83.5625 64.2958 83.5625 64.8136V82.6261C83.5625 83.1439 83.1428 83.5636 82.625 83.5636H64.8125C64.2947 83.5636 63.875 83.1439 63.875 82.6261V64.8136C63.875 64.2958 64.2947 63.8761 64.8125 63.8761Z",
    fill: "#959BA1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoProduct);
export default __webpack_public_path__ + "static/media/noProduct.0d11d070332db0a2c452b365f615f783.svg";
export { ForwardRef as ReactComponent };